import { useEffect, useState } from "react";
import PermissionDeniedNotice from "components/common/PermissionDeniedNotice";
import { permissionDeniedStore, type PermissionDenial, type PermissionDeniedStore } from "./permissionDenied";

type Props = {
  store?: PermissionDeniedStore;
};

// tenant-backend-v2 がロールの権限不足で断ったら、どの画面でも同じ通知を出す（lib/tenantApiClient.ts の middleware から届く）。
// 画面ごとのエラー表示（「サーバーエラー」など）だけでは、権限が理由だと分からないため
export const PermissionDeniedNoticeHost = ({ store = permissionDeniedStore }: Props) => {
  const [denial, setDenial] = useState<PermissionDenial | null>(null);

  useEffect(() => store.subscribe(setDenial), [store]);

  return <PermissionDeniedNotice denial={denial} onClose={() => setDenial(null)} />;
};
